<template>
  <div class="content container">
    <div class="chatroom">
    <div class="card">
      <h5 v-if="content"class="center grey-text text-darken-2">{{ content.title }}</h5>
    <ul class="comments collection" v-chat-scroll>
      <li v-for="comment in comments">
        <span class="comment-user cyan-text text-darken-1">{{ comment.from }}</span>
        <span class="time grey-text right">{{ comment.time }}</span>
        <p class="comment-text grey-text text-darken-2">{{ comment.talkContent }}</p>
      </li>
    </ul>
    </div>
      <div class="field">
        <i class="tiny material-icons">mode_edit</i>
        <textarea class="materialize-textarea" v-model="newComment"></textarea>

        <a class="waves-effect waves-light btn" @click="addComment">投稿</a>
        <p v-if="feedback" class="red-text center">{{ feedback }}</p>
      </div>
    </div>
  </div>

</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'
import moment from 'moment'

export default{
  name: 'Content',
  data(){
    return{
      user: null,
      content: null,
      talkContent: null,
      slug: null,
      newComment: null,
      feedback: null,
      comments: []
      }
    },

    created(){
      this.slug = this.$route.params.slug

      let ref = db.collection('contents').where('title', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
          this.content = doc.data()
          this.content.id = doc.id
        })
      });
      db.collection('users').where('user_id', '==', firebase.auth().currentUser.uid).get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        this.user = doc.data()
        this.user.id = doc.id
      })
    });
    db.collection('comments').where('to', '==', this.$route.params.slug).orderBy('time')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(change => {
        if(change.type == 'added'){
          this.comments.push({
            from: change.doc.data().from,
            talkContent: change.doc.data().talkContent,
            time: moment(change.doc.data().time).format('lll')
          })
        }
      })
    })
  },

    methods: {
      addComment(){
        if(this.newComment){
          this.feedback = null
          db.collection('comments').add({
            to: this.$route.params.slug,
            from: this.user.id,
            talkContent: this.newComment,
            time: Date.now()
          }).then(doc => {
            this.newComment = null
          })
      } else {
        this.feedback = 'You must enter a comment to add it'
      }
    }
  }




  }
</script>

<style>


.content h5{
  font-size: 2em;
  margin-top: 50px;
}
.content li{
  padding: 10px;
  border-bottom: 1px solid #eee
}
.content .time{
  display: block;
  font-size: 0.6em;
}

.comments{
  margin-top: 0px;
  max-height: 400px;
  overflow: auto;
}
.comments::-webkit-scrollbar {
  width: 3px;
}
.comments::-webkit-scrollbar-track {
  background: #ddd;
}
.comments::-webkit-scrollbar-thumb {
  background: #aaa;
}
.content-title{
  margin-top: 50px;
}
.comment-text{
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1em;
}
.comment-user{
  font-size: 1em;
}
.field input {
  max-width: 400px;
}
.chatroom{
  max-width: 600px;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/Content.vue